import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableNfs from "./components/TableNfs";

export function NfsRegisterPage() {

  return (
    <ToastProvider>
      <Dashboard>
        <TableNfs />
        <Toast />
      </Dashboard>
    </ToastProvider>
  )
}